<script>
  export let level = 'OPERATIONAL'; // OPERATIONAL | DEGRADED | CRITICAL
  export let message = 'All systems running smoothly';
  export let compact = false;

  const config = {
    OPERATIONAL: { color: 'var(--neon-green)', bg: 'rgba(16, 185, 129, 0.1)', border: 'rgba(16, 185, 129, 0.3)', icon: 'check' },
    DEGRADED: { color: 'var(--neon-orange)', bg: 'rgba(245, 158, 11, 0.1)', border: 'rgba(245, 158, 11, 0.3)', icon: 'warning' },
    CRITICAL: { color: 'var(--neon-red)', bg: 'rgba(239, 68, 68, 0.1)', border: 'rgba(239, 68, 68, 0.3)', icon: 'alert' },
  };

  $: style = config[level] || config.OPERATIONAL;
</script>

<div
  class="status-badge"
  class:compact
  style="--status-color: {style.color}; --status-bg: {style.bg}; --status-border: {style.border};"
>
  {#if style.icon === 'check'}
    <svg width={compact ? 18 : 24} height={compact ? 18 : 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
    </svg>
  {:else if style.icon === 'warning'}
    <svg width={compact ? 18 : 24} height={compact ? 18 : 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  {:else}
    <svg width={compact ? 18 : 24} height={compact ? 18 : 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  {/if}

  <div class="status-text">
    <span class="status-level">{level}</span>
    {#if !compact}
      <span class="status-message">{message}</span>
    {/if}
  </div>
</div>

<style>
  .status-badge {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 20px;
    background: var(--status-bg);
    border: 1px solid var(--status-border);
    border-radius: var(--radius-md);
    color: var(--status-color);
  }

  .status-badge.compact {
    padding: 8px 14px;
    gap: 8px;
  }

  .status-badge svg {
    filter: drop-shadow(0 0 8px currentColor);
    flex-shrink: 0;
  }

  .status-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .status-level {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  .compact .status-level {
    font-size: 12px;
  }

  .status-message {
    font-size: 12px;
    color: var(--text-secondary);
  }
</style>
